import script from "./BannerTempTwo.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerTempTwo.vue?vue&type=script&setup=true&lang=js"

import "./BannerTempTwo.vue?vue&type=style&index=0&id=73f48d50&lang=scss&scoped=true"
import "./BannerTempTwo.vue?vue&type=style&index=1&id=73f48d50&lang=scss"

import exportComponent from "F:\\ubuntuBK\\sombardc\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73f48d50"]])

export default __exports__